module.exports = __webpack_public_path__ + "fonts/montserrat-latin-500.edd3115.woff";